import { motion } from "framer-motion";

// Fade + rise reveal on scroll.
export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for editorial headlines.
// Uses variants so the UN-transformed parent drives viewport detection
// (the translated child would otherwise report an offset box to the observer).
export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, mount = false }) {
  const parent = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "120%" },
    show: { y: "0%", transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
  };
  const trigger = mount
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, margin: "-80px" } };
  return (
    <motion.span className={className} initial="hidden" variants={parent} {...trigger}>
      {lines.map((line) => (
        <span key={line} className="mask-line">
          <motion.span className={`block py-[0.16em] ${lineClassName}`} variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}
